import moment from 'moment';
import { ListTable } from '@/Components/ListTable';

const SPECIAL_COLUMNS = [
	{
		title: 'QR Code',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Asset ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Asset Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Asset Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Activity Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Quantity',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Post Update Stock',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Ref. ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Reference Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Activity At',
		config: {
			type: 'DATA',
		},
	},
];

const COLMAP = {
	'Asset ID': 'assetId',
	'Asset Type': 'assetType',
	'Asset Name': 'assetName',
	'Activity Type': 'activityType',
	'QR Code': 'qrCode',
	Quantity: 'qty',
	'Ref. ID': 'refId',
	'Reference Type': 'refType',
	'Activity At': 'createdAt',
	'Post Update Stock': 'postUpdateStock',
};

function AssetScanWiseTable(props) {
	const { data } = props;

	const specialItems = {
		'Asset ID': (id, item) => {
			return <div className='text-[12px]'>{item}</div>;
		},
		'Asset Type': (id, item) => {
			return <div className='text-nowrap text-[12px]'>{item}</div>;
		},
		'Asset Name': (id, item) => {
			return <div className='text-nowrap text-[12px]'>{item}</div>;
		},
		'Activity Type': (id, item) => {
			return <div className='text-nowrap text-[12px]'>{item}</div>;
		},
		'QR Code': (id, item) => {
			return <div className='text-[12px] text-nowrap'>{item}</div>;
		},
		Quantity: (id, item) => {
			return <div className='text-[12px]'>{item}</div>;
		},
		'Ref. ID': (id, item) => {
			return <div className='text-[12px]'>{item}</div>;
		},
		'Reference Type': (id, item) => {
			return <div className='text-[12px]'>{item}</div>;
		},
		'Activity At': (id, item) => {
			return <div className='text-[12px]'>{moment(item).format('DD-MM-YYYY hh:mm:ss')}</div>;
		},
		'Post Update Stock': (id, item) => {
			return <div className='text-[12px]'>{item}</div>;
		},
	};
	return (
		<div>
			<ListTable
				data={data}
				actions={SPECIAL_COLUMNS}
				colMap={COLMAP}
				special={specialItems}
			/>
		</div>
	);
}

export default AssetScanWiseTable;
